module.exports = __webpack_public_path__ + "img/panchito-hand.7bca5c66.png";